export default __webpack_public_path__ + "static/media/closet4-1440w.eb6e9c17.webp";